import PropertyForm from "@/components/PropertyForm";
import LandlordAiIntro from "@/components/LandlordAiIntro";

export default function ListPropertyPage() {
  return (
    <>
      <LandlordAiIntro />
      <PropertyForm mode="create" />
    </>
  );
}
